import {ReactElement, MutableRefObject} from 'react';

import {FileOperationResponseBody, VehicleAlbum} from '@dms/api/shared';

import {TestIdProps} from 'shared/web';

import {ContextMenuOption} from '../../ContextMenu/utils/types';
import {HoverPositions} from '../../CustomDragAndDrop/utils/types';
import {CardProps} from '../../TypographyCard/TypographyCard';

export type ImageType = {
  id: string;
  albumId?: string;
  fileId?: string;
  url?: string;
  resizeUrl?: string;
  base64Url?: string;
  weight?: number;
  isSelected?: boolean;
  isCoverPhoto?: boolean;
  latestFileOperation?: FileOperationResponseBody | null;
  name?: string;
  note?: string;
  originalUri?: string;
  [key: string]: unknown;
  isPromoPhoto?: boolean;
};

export type ImageRendererProps = {
  image: {latestFileOperation?: FileOperationResponseBody | null} & ImageType;
  index: number;
  handleImageSelection: (id: string) => void;
  disableDrag: boolean;
  showPointer?: boolean;
  selectionEnabled: boolean;
  tooltipRenderer?: ((children: ReactElement) => ReactElement) | null;
  contextMenuOptions: ImagesCardProps['contextMenuOptions'];
  getSelectedImages: (ids: string[]) => ImageType[];
  selectedPhotos?: string[];
};

export type UploadingFileType = {
  name: string;
  progress: number;
};

export type Images = {
  images: ImageType[];
  onImageClick?: (imageId: string) => void;
};

export type ContextMenuOptions = (image: ImageType[]) => ContextMenuOption[];

export type ImagesCardProps = {
  album?: VehicleAlbum;
  droppableId?: string;
  disableDrag?: boolean;
  isUploadDisabled?: boolean;
  infoText?: string;
  cardProps?: CardProps;
  selectionActive?: boolean;
  globalListener?: boolean;
  selectionEnabled?: boolean;
  contextMenuOptions?: ContextMenuOptions;
  onSelectionToggle?: () => void;
  onImageSelect?: (imageId: string) => void;
  onUpload?: (
    e: File[],
    setUploadingState: (id: string) => (state?: UploadingFileType) => void
  ) => void;
  onAllImagesUploaded?: () => void;
  enableGallery?: boolean;
  onGalleryToggle?: () => void;
  withTooltip?: boolean;
  selectedPhotos?: string[];
  promoPhotos?: boolean;
  onAddPromoPhotos?: () => void;
  onSetDefaultOrder?: () => void;
  onDelete?: (images: ImageType[]) => void;
  isDeleteDisabled?: boolean;
  isBackgroundRemovalAvailable?: boolean;
  handleBackgroundRemoval?: (imageIds: string[], canDeselect: boolean) => void;
  differentPosition?: boolean;
  selectedImageIds?: string[];
  vehicleId?: string;
  isAddForm?: boolean;
} & Images &
  TestIdProps;

export type UploadingImagesRefState = {
  photos: {[key: string]: UploadingFileType};
  updateCb: () => void;
};

export type UploadingImageProps = {
  refImages: MutableRefObject<UploadingImagesRefState>;
};

export type ProgressBarProps = {
  percentage: number;
};

export type EmptyWrapperProps = {
  active: boolean;
  infoText?: boolean;
};

export type ImagesWrapperProps = {
  active: boolean;
};

export type SelectionProps = {
  isSelected?: boolean;
  selectionEnabled?: boolean;
  isDragging?: boolean;
  borderSide?: HoverPositions;
  isChecked?: boolean;
};

export type ImageProps = {
  src?: string;
  isDragged?: boolean;
} & SelectionProps;
